// actions to get slides text from the database
import axios from "axios";
import { API_URL } from "../variables";

export const FETCH_SLIDES_TEXT_REQUEST = "FETCH_SLIDES_TEXT_REQUEST";
export const FETCH_SLIDES_TEXT_SUCCESS = "FETCH_SLIDES_TEXT_SUCCESS";
export const FETCH_SLIDES_TEXT_FAILURE = "FETCH_SLIDES_TEXT_FAILURE";

export const getSlidesText = () => async (dispatch) => {
  dispatch({ type: FETCH_SLIDES_TEXT_REQUEST });
  try {
    const response = await axios.get(
      `${API_URL}/api/users/slides/texts/get-active`
    );
    dispatch({ type: FETCH_SLIDES_TEXT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_SLIDES_TEXT_FAILURE, payload: error.message });
  }
};
